import mongoose from 'mongoose/browser'

export default class Model {
  #model
  #save = async function(doc) {
    await doc.validate()
    console.log('Pseudo save')
  }

  constructor(Schema) {
    this.#model = Schema
  }

  async create(params, skipValidation) {
    const doc = new mongoose.Document(params, this.#model)
    if (!skipValidation) {
      await doc.validate()
      if (typeof doc.initializeTimestamps === 'function')
        await doc.initializeTimestamps()
    }
    Object.defineProperty(doc, 'save', { get: () => () => this.#save(doc) })
    return doc
  }

  createSync(params) {
    const doc = new mongoose.Document(params, this.#model)
    // Object.defineProperty(doc, 'save', { get: () => () => this.#save(doc) })
    return doc
  }

  get schema() {
    return this.#model
  }
}
